module.exports = __webpack_public_path__ + "img/11.eff77076.png";